import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "@/components/site/Reveal";
import { useAuth } from "@/context/AuthContext";

const TrialCta = () => {
    const { user } = useAuth();
    return (
    <section data-testid="trial-cta-section" className="px-5 py-14 sm:px-8 sm:py-20">
        <FadeUp>
            <div className="relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] border border-white/[0.08] bg-[#0b1422] px-6 py-12 text-center sm:px-12 sm:py-16">
                <div className="pointer-events-none absolute -left-24 top-0 h-72 w-72 rounded-full bg-[#3fcbf3]/15 blur-[110px]" />
                <div className="pointer-events-none absolute -right-24 bottom-0 h-72 w-72 rounded-full bg-[#f0356f]/15 blur-[110px]" />
                <div className="relative">
                    <p className="eyebrow">Your move</p>
                    <h2 className="font-display mx-auto mt-4 max-w-3xl text-4xl leading-[1.06] text-white sm:text-5xl lg:text-6xl">
                        Start your 7-day free trial.
                    </h2>
                    <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[#9fb0c7]">
                        Create your free account and start your 7-day trial — full SHREDxpro access
                        in the mobile app. No card, no payment, cancel anytime.
                    </p>
                    <div className="mt-10 flex justify-center">
                        <Link to={user ? "/trial" : "/register?trial=1"} data-testid="trial-band-cta" className="btn-primary">
                            Start 7-Day Free Trial <ArrowRight className="h-4 w-4" />
                        </Link>
                    </div>
                    <p className="mt-6 text-xs font-bold uppercase tracking-[0.2em] text-[#7d8da3]">
                        7 days free · Full access · Cancel anytime · iOS &amp; Android
                    </p>
                </div>
            </div>
        </FadeUp>
    </section>
    );
};

export default TrialCta;
